import { LoadingDots } from '@/components/animations/loading-dots';
import { Box, SxProps, Theme } from '@rhg/libs/material';
import AiJournalingPageContainer from '../../page-container';

const styleCenter: SxProps<Theme> = {
    gridRow: '1 / -1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

interface JournalingLoadingScreenProps {
    hasGlobalHeader?: boolean;
}

function JournalingLoadingScreen({
    hasGlobalHeader,
}: JournalingLoadingScreenProps) {
    return (
        <AiJournalingPageContainer hasGlobalHeader={hasGlobalHeader}>
            <Box sx={styleCenter} data-testid="journal-loading-screen">
                <LoadingDots loop />
            </Box>
        </AiJournalingPageContainer>
    );
}

export default JournalingLoadingScreen;
